import { Vector2 } from 'three';

import glslScale from '@/libs/lygia/space/scale.glsl';

export const uniforms = () => {
    return {
        tScene: { value: null },
        uRectSize: { value: new Vector2(0.5, 0.5) },
        uRectOffset: { value: new Vector2(0, 0) },
    };
};
export const shaderChunks = {
    uniforms: /* glsl */ `
        uniform sampler2D tScene;
        uniform vec2 uRectSize;
        uniform vec2 uRectOffset;
    `,
    funcs: /* glsl */ `
        ${glslScale}
        vec4 getSceneColor(sampler2D sceneTex, vec4 screenPosition) {
            vec2 uvScene = screenPosition.xy / screenPosition.w;
            uvScene = uvScene * 0.5 + 0.5;
            
            return texture2D(sceneTex, uvScene);
            // return texture2D(uvScene, vUv).rgb;
            // return vec3(uvScene, 1.0);
        }
    `,
};
